import { createSlice } from "@reduxjs/toolkit";

const navigatorSlice = createSlice({
  name: "navigation",
  initialState: {
    page: "",
  },
  reducers: {
    navigateTo: (state, action) => {
      state.page = action.payload;
    },
    removeNavigator: (state) => {
      state.page = "";
    },
  },
});

export const { navigateTo, removeNavigator } = navigatorSlice.actions;
export default navigatorSlice.reducer;
